import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: false,
    user: null,
    subKeys: null,
  },
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    setSubKeys: (state, action) => {
      state.subKeys = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.subKeys = null;
    },
  },
});

export const { login, setSubKeys, logout } = authSlice.actions;

export default authSlice.reducer;
